import { numberUtils } from '@/utils/number'
import { billTypeTagType } from '../constants'

const yuan = (v) => (v == null || v === '' ? '--' : `¥${numberUtils.format(v)}`)

// h 为 createElement(由详情页 setup 传入 proxy.$createElement)。QSCommonTable 把列 render
// 当 scopedSlot 返回，不绑 this、不传 h，故列 render 用箭头函数闭包捕获此处的 h。
// 展示列用 minWidth(可被 el-table fit 拉伸撑满容器)，操作列 fixed:'right' + 固定 width，
// 使列宽和始终撑满、fixed 操作列贴右不留空白(参考 entOrder/primaryOrder)。
export function createReceivableColumns({ onFollow, h }) {
  return [
    {
      name: 'billType',
      columnProps: { label: '账单类型', minWidth: 100 },
      render: (scope) =>
        h(
          'el-tag',
          { props: { type: billTypeTagType(scope.row.billType), size: 'small' } },
          scope.row.billTypeName || '--',
        ),
    },
    { name: 'periodNum', columnProps: { label: '期数', prop: 'periodNum', minWidth: 80, align: 'center' } },
    { name: 'plateNo', columnProps: { label: '车牌', prop: 'plateNo', minWidth: 100 } },
    { name: 'billCycle', columnProps: { label: '账单周期', prop: 'billCycle', minWidth: 180 } },
    {
      name: 'receivableAmount',
      columnProps: { label: '应收金额', minWidth: 120, align: 'right' },
      getText: ({ row }) => yuan(row.receivableAmount),
    },
    {
      name: 'receivingAmount',
      columnProps: { label: '收款中', minWidth: 100, align: 'right' },
      render: (scope) => h('span', { style: 'color:#faad14' }, yuan(scope.row.receivingAmount)),
    },
    {
      name: 'receivedAmount',
      columnProps: { label: '已收金额', minWidth: 120, align: 'right' },
      render: (scope) => h('span', { style: 'color:#52c41a' }, yuan(scope.row.receivedAmount)),
    },
    {
      name: 'surplusAmount',
      columnProps: { label: '欠款金额', minWidth: 120, align: 'right' },
      render: (scope) =>
        h('span', { style: 'color:#ff4d4f;font-weight:bold' }, yuan(scope.row.surplusAmount)),
    },
    {
      name: 'overdueDays',
      columnProps: { label: '逾期天数', minWidth: 100, align: 'right' },
      render: (scope) =>
        h('span', { style: 'color:#ff4d4f' }, `${scope.row.overdueDays ?? '--'}天`),
    },
    {
      name: 'status',
      columnProps: { label: '状态', minWidth: 90 },
      render: (scope) =>
        h(
          'el-tag',
          { props: { type: scope.row.status === 1 ? 'success' : 'danger', size: 'small' } },
          scope.row.statusName || '--',
        ),
    },
    { name: 'followStateName', columnProps: { label: '跟进状态', prop: 'followStateName', minWidth: 100 } },
    { name: 'followCount', columnProps: { label: '跟进次数', prop: 'followCount', minWidth: 90, align: 'center' } },
    {
      name: 'operate',
      type: 'operate',
      columnProps: { label: '操作', width: 90, fixed: 'right' },
      getOperateList: ({ row }) => [{ name: 'follow', label: '跟进', action: () => onFollow(row) }],
    },
  ]
}
